import { render, staticRenderFns } from "./tripCommentView.vue?vue&type=template&id=482d0bc0&scoped=true&"
import script from "./tripCommentView.vue?vue&type=script&lang=js&"
export * from "./tripCommentView.vue?vue&type=script&lang=js&"
import style0 from "./tripCommentView.vue?vue&type=style&index=0&id=482d0bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482d0bc0",
  null
  
)

export default component.exports